import React from "react";
import { observer } from "mobx-react";
import { Switch } from "antd";

import Group from "../group";

const RiskToggle = observer(({ config, onChange, readonly = false }) => {
    /**
     * Toggle a value and send the change event
     */
    const toggle = (key, value) => {
        config[key] = value;

        const data = {
            enabled: config.enabled,
        };

        onChange && onChange(data);
    };

    return (
        <Group title="Risk Configuration">
            <div className="toggle">
                <div className="row items-center mb-15 ml-15">
                    <Switch
                        checked={config.enabled}
                        onChange={(value) => {
                            toggle("enabled", value);
                        }}
                        disabled={readonly}
                    />
                    <div className="col ml-15">Enable risk reports and Maude database</div>
                </div>
            </div>
        </Group>
    );
});

export default RiskToggle;
